var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "table-new-ux-v1",
      class: {
        "table-new-ux-v1--clickable": _vm.hasRowClick,
        "az-card-bordered base-table--bordered az-table-bleed": _vm.bordered
      }
    },
    [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", [
          _vm.title && _vm.title.length
            ? _c("h1", { staticClass: "az-ds-table-title" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ])
            : _vm._e(),
          _vm.hasSubtitle
            ? _c(
                "p",
                { staticClass: "az-ds-table-subtitle mb-0 mt-1" },
                [_vm._t("subtitle", [_vm._v(_vm._s(_vm.subtitle))])],
                2
              )
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "d-flex align-center az-gap-small" },
          [
            _vm._t("cornerAction"),
            _vm.showSearch
              ? _c("InputByType", {
                  attrs: {
                    value: _vm.searchInput,
                    type: "search",
                    "max-width": "250px",
                    placeholder: _vm.searchPlaceholder || undefined,
                    clearable: _vm.searchClearable
                  },
                  on: { input: _vm.onSearchInput }
                })
              : _vm._e()
          ],
          2
        )
      ]),
      _c(
        "v-data-table",
        _vm._g(
          _vm._b(
            {
              class: { "mt-4": !_vm.disableMarginTop },
              attrs: {
                page: _vm.isPageControlled ? _vm.$attrs.page : _vm.tablePage,
                "items-per-page": _vm.isItemsPerPageControlled
                  ? _vm.$attrs["items-per-page"]
                  : _vm.tableItemsPerPage,
                search: _vm.externalSearch ? "" : _vm.effectiveSearch,
                "footer-props": _vm.footerProps,
                "hide-default-footer": ""
              },
              on: {
                pagination: _vm.onPagination,
                "update:sort-by": _vm.onSort
              },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.passthroughSlotNames, function(name) {
                    return {
                      key: name,
                      fn: function(slotProps) {
                        return [_vm._t(name, null, null, slotProps)]
                      }
                    }
                  })
                ],
                null,
                true
              )
            },
            "v-data-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm.hasFooterSlot
        ? _vm._t("footer", null, null, _vm.effectivePagination)
        : _vm.showFooter
        ? _c("BaseTableFooter", {
            attrs: {
              "show-items-per-page-selector": _vm.showItemsPerPageSelector,
              "items-per-page-model": _vm.itemsPerPageModel,
              "items-per-page-options": _vm.itemsPerPageOptions,
              "footer-summary": _vm.footerSummary,
              "pagination-data": _vm.effectivePagination
            },
            on: {
              "change-items-per-page": _vm.changeItemsPerPage,
              "go-to-page": _vm.goToPage
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }